<template>
  <div>
    <div :class="[ 'ls-collapse',  showCollapse ? 'ls-collapse-opened' : '' ]">
      <a @click="toggleCollapse()" class="ls-collapse-header"   >
        <h3 class="ls-collapse-title">{{ parseType(type) }}</h3>
      </a>
      <div v-if="type" class="ls-collapse-body">
        <div v-if="paymentMethods && paymentMethods.length" class="edit-all">
          <a href="javascript:void(0)" class="ls-btn-sm ls-float-right" @click="editAll()">Editar todos</a>
        </div>
        <div v-if="paymentMethods && paymentMethods.length" style="overflow-y: auto; height: 50vh;">
          <table class="ls-table">
            <thead>
            <tr>
              <th class="ls-no-padding"></th>
              <th class="ls-no-padding"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for='paymentMethod, index in paymentMethods'>
              <td><img class="ls-float-left ls-md-margin-right" :src="paymentMethod.logo" alt="logo cartão" width="35">{{paymentMethod.method }}</td>
              <td><router-link slot="button" :to="{ name: 'edit_payment_settings', params: { processor: processor, method: paymentMethod.name }}" class="ls-btn ls-float-right">{{ $t('application.button.edit') }}</router-link></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="ls-alert-warning"><strong>{{ $t('application.alert.warning') }}</strong> {{ $t('settings.alerts.payment_methods_not_found') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'

  export default {
    name: 'collapse-payment-type',
    props: ['type'],
    components: {
      Dropdown
    },
    data () {
      return {
        showCollapse: false,
        active: { show: false },
        inactive: { show: false },
        selected: []
      }
    },
    computed: {
      ...mapGetters(['paymentMethods']),
      selectAll: {
        get: function () {
          return this.paymentMethods ? this.selected.length === this.paymentMethods.length : false
        },
        set: function (value) {
          this.selected = []
          if (value) {
            for (var i = 0; i < this.paymentMethods.length; i++) {
              this.selected.push(this.paymentMethods[i].name)
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadPaymentMethods', 'loadProcessors']),
      toggleCollapse () {
        this.$helper.$emit('closeCollapses', this.type)
        this.showCollapse = !this.showCollapse
        if (this.showCollapse) {
          this.$loader.show()
          this.loadPaymentMethods({type: this.type, processor: this.processor}).then(this.$loader.hide)
        }
      },
      status (status) {
        return status ? 'ls-tag-success' : 'ls-tag-default'
      },
      closeCollapse (type) {
        if (this.type !== type) {
          this.showCollapse = false
        }
      },
      editAll () {
        this.$router.push({name: 'edit_payment_methods', params: {paymentMethods: this.paymentMethods}})
      },
      parseType (type) {
        switch (type) {
          case 'c': return 'Crédito '
          case 'b': return 'Boleto'
        }
      },
      loadMethods () {
      },
      showModal (modal, index) {
        modal.payment = { processor: this.processor, method: this.paymentMethods[index].name }
        modal.show = true
      }
    },
    mounted () {
      this.processor = this.$route.params.processor
      this.$helper.$on('closeCollapses', this.closeCollapse)
    },
    beforeDestroy () {
      this.$helper.$off('closeCollapses')
    }
  }
</script>
<style>
  .edit-all{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
</style>



// WEBPACK FOOTER //
// PaymentList.vue?20fffc83